export default "__VITE_ASSET__73593239__"